.form { display: flex; flex-direction: column; gap: 14px; }

.section {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  margin: 6px 0 2px;
}

.field { display: flex; flex-direction: column; gap: 6px; }

.fieldLabel {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--color-ink-soft);
}

.fieldLabel em { color: var(--color-ember-dark); margin-left: 4px; font-style: normal; }

.input, .textarea {
  border: 1px solid rgba(0, 0, 0, 0.18);
  background: #fff;
  padding: 10px 12px;
  font: inherit;
  font-size: 0.95rem;
  border-radius: 4px;
  outline: none;
}

.input:focus, .textarea:focus {
  border-color: var(--color-ember);
  box-shadow: 0 0 0 3px rgba(243, 154, 46, 0.18);
}

.textarea { font-family: inherit; resize: vertical; }

.grid2, .grid3 {
  display: grid;
  gap: 12px;
}

.grid2 { grid-template-columns: 1fr 1fr; }
.grid3 { grid-template-columns: 2fr 1fr 1fr; }

.methods {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.method {
  display: grid;
  grid-template-columns: 22px 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
  transition: border-color 120ms ease, background 120ms ease;
}

.methodActive {
  border-color: var(--color-ember);
  background: #fffaf2;
  box-shadow: 0 0 0 2px rgba(243, 154, 46, 0.18);
}

.methodLabel {
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.methodSub {
  font-size: 0.74rem;
  font-weight: 500;
  color: var(--color-ink-soft);
  letter-spacing: 0.04em;
  text-transform: none;
}
.methodPrice { color: var(--color-ink-soft); font-size: 0.85rem; }

.poBanner {
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(102, 67, 219, 0.08);
  border: 1px solid rgba(102, 67, 219, 0.25);
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 0.92rem;
}

.poBanner strong { font-size: 1rem; color: #4928bd; }

.cardStub {
  margin-top: 4px;
  padding: 12px 14px;
  background: var(--color-bone);
  border-radius: 6px;
  color: var(--color-ink-soft);
  font-size: 0.9rem;
}

.actions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 10px;
  flex-wrap: wrap;
}

.back, .next {
  border: 0;
  padding: 14px 18px;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.back { background: transparent; color: var(--color-ink); border: 1px solid rgba(0, 0, 0, 0.18); }
.back:hover { background: var(--color-bone); }

.next { background: var(--color-ember); color: #111; }
.next:hover { background: var(--color-ember-dark); color: #fff; }
.next:disabled { opacity: 0.6; cursor: not-allowed; }

.reviewBlocks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.block {
  background: var(--color-bone);
  border-radius: 8px;
  padding: 14px;
}

.blockTitle {
  margin: 0 0 6px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--color-ink-soft);
}

.blockBody { font-size: 0.92rem; line-height: 1.5; }

.muted { color: var(--color-ink-soft); }

.lineList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.lineItem {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  font-size: 0.92rem;
}

.lineQty { color: var(--color-ink-soft); }
.lineAmount { font-weight: 700; }

.lineTotal {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-top: 12px;
  font-size: 1.05rem;
}

.lineTotal strong { font-size: 1.2rem; }

.error {
  background: rgba(181, 59, 59, 0.08);
  border: 1px solid rgba(181, 59, 59, 0.4);
  color: #7a2828;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 0.9rem;
}

.successCard {
  text-align: center;
  padding: 32px 24px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.successIcon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #2e9d57;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}

.successTitle {
  font-family: var(--font-display);
  font-size: 1.6rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  margin: 0;
}

.successLede {
  color: var(--color-ink-soft);
  max-width: 56ch;
  margin: 0;
}

.successDetails {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px 18px;
  margin-top: 16px;
  text-align: left;
  width: 100%;
  max-width: 400px;
}

.successDetails dt { color: var(--color-ink-soft); font-weight: 600; }
.successDetails dd { margin: 0; }

.mono { font-family: ui-monospace, "SF Mono", Menlo, monospace; }

.statusPill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.statusOk { background: rgba(46, 157, 87, 0.14); color: #2e9d57; }
.statusPending { background: rgba(243, 154, 46, 0.18); color: var(--color-ember-dark); }

@media (max-width: 768px) {
  .grid2, .grid3 { grid-template-columns: 1fr; }
  .reviewBlocks { grid-template-columns: 1fr; }
  .actions { gap: 8px; }
  .actions > * { flex: 1; }
}
